export default {"src":"/_next/static/media/favicon.f9d9be67.ico","height":32,"width":32,"blurWidth":0,"blurHeight":0};